<span class="inline-flex h-[22px] w-[22px] items-center justify-center rounded-full bg-white shadow-sm ring-1 ring-black/5"
  [attr.aria-label]="ariaLabel || label || null" [attr.title]="ariaLabel || label || null">
  <img src="/assets/svg/info-alert-circle.svg" alt="" class="h-[15px] w-[15px]" />
</span>
